import React, { FunctionComponent, useState } from 'react';

import Form from './Form';

const SavedCards: FunctionComponent<{
  list: Array<object>;
  amount: number;
  type: string;
  updateInternetCharges: Function;
  paymentInfo: any;
  internetCharges: number;
  fromFastag: any;
}> = ({ list, amount, type, updateInternetCharges, paymentInfo, internetCharges, fromFastag }) => {
  const [activeCard, setActiveCard] = useState({ name: '', value: '' });

  const changeHandler = (name: string, value: string) => {
    setActiveCard({ name, value });
  };

  return (
    <div>
      {list.map((card: any) => (
        <Form
          changeHandler={changeHandler}
          activeCard={activeCard}
          amount={amount}
          name={card.cardDetails.cardId}
          data={card}
          type={type}
          updateInternetCharges={updateInternetCharges}
          key={card.cardDetails.cardId}
          paymentInfo={paymentInfo}
          internetCharges={internetCharges}
          fromFastag={fromFastag}
        />
      ))}
    </div>
  );
};

export default SavedCards;
